import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'

import { cn } from '@/lib/utils'

function Tabs({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
    return (
        <TabsPrimitive.Root
            data-slot="tabs"
            className={cn(
                'size-full flex flex-col gap-2',
                'shadow-sm dark:shadow-none rounded-md',
                'dark:bg-card/50',
                className,
            )}
            {...props}
        />
    )
}

function TabsList({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                'border dark:border-0 dark:bg-card p-1 gap-1',
                'flex h-10 min-h-10 max-w-full items-center justify-start rounded-lg',
                'overflow-x-auto overflow-y-hidden scrollbar-thin',
                'select-none',
                className,
            )}
            {...props}
        />
    )
}

function TabsTrigger({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            className={cn(
                'bg-card data-[state=inactive]:cursor-pointer hover:bg-primary/20',
                'data-[state=active]:bg-primary data-[state=inactive]:text-foreground',
                'text-primary-foreground dark:data-[state=inactive]:text-foreground',
                'flex h-[calc(100%-1px)]',
                'flex-1 items-center justify-center',
                'gap-1.5 rounded-md border border-transparent',
                'px-2 py-1 text-sm font-medium',
                'whitespace-nowrap transition-colors duration-150',
                'focus-visible:ring-[3px] focus-visible:outline-1',
                'disabled:pointer-events-none disabled:opacity-50',
                'disabled:border-none',
                'data-[state=active]:shadow-sm',
                "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                'min-w-fit disabled:cursor-not-allowed group-disabled:cursor-not-allowed',
                className,
            )}
            {...props}
        />
    )
}

function TabsContent({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
    return (
        <TabsPrimitive.Content
            data-slot="tabs-content"
            className={cn('flex-1 outline-none p-4 pt-0', className)}
            {...props}
        />
    )
}

export { Tabs, TabsContent, TabsList, TabsTrigger }
